import {
  ListItemText,
  ListItemAvatar,
  Divider,
  useTheme,
  Box,
  CardMedia,
  SxProps,
  ListItemTextProps,
  ListItemButton,
} from "@mui/material"
import { deepmerge } from "@mui/utils"

interface IEndAdornmentSlotClasses {
  text?: string
  media?: string
}

interface IEndAdornmentSlots {
  text?: string
  media?: string
}

interface IFeatureListItemProps {
  primary?: React.ReactNode
  secondary?: React.ReactNode
  onClick?: () => void
  avatar?: React.ReactNode
  divider?: boolean
  primaryTypographyProps?: Pick<ListItemTextProps, "primaryTypographyProps">
  secondaryTypographyProps?: Pick<ListItemTextProps, "secondaryTypographyProps">
  disableTypography?: boolean
  sx?: SxProps
  endAdornmentSlotClasses?: IEndAdornmentSlotClasses
  endAdornmentSlots?: IEndAdornmentSlots
  className?: string
  startAdornment?: React.ReactNode
}

export const FeatureListItem = (props: IFeatureListItemProps) => {
  const {
    primary = "",
    secondary = "",
    onClick = () => {},
    avatar = null,
    divider,
    primaryTypographyProps = {},
    secondaryTypographyProps = {},
    disableTypography,
    sx,
    startAdornment = null,
    endAdornmentSlotClasses = {},
    endAdornmentSlots = {},
    className,
    ...restProps
  } = props
  const theme = useTheme()
  const styleOverrides =
    theme.components[`FeatureListItem`]?.styleOverrides || {}
  const {
    root,
    adornmentWrapper,
    adornmentDivider,
    adornmentTextAvatar,
    adornmentMedia,
    listItemText,
    listItemAvatar,
    listItemContent,
    bottomDivider,
    listItemWrapper,
  } = styleOverrides
  return (
    <>
      <ListItemButton
        sx={deepmerge(root, sx)}
        className={className}
        onClick={onClick}
        disableGutters
        {...restProps}
      >
        <ListItemAvatar sx={listItemAvatar}>{avatar}</ListItemAvatar>
        <Box sx={listItemContent}>
          <Box sx={listItemWrapper}>
            {startAdornment}

            <ListItemText
              sx={listItemText}
              primaryTypographyProps={{
                variant: "title",
                component: "h6",
                ...primaryTypographyProps,
              }}
              secondaryTypographyProps={{
                variant: "subTitle",
                component: "p",
                ...secondaryTypographyProps,
              }}
              primary={primary}
              secondary={secondary}
              disableTypography={disableTypography}
            />
          </Box>
          {(endAdornmentSlots.text || endAdornmentSlots.media) && (
            <Box sx={adornmentWrapper}>
              <Divider
                sx={adornmentDivider}
                orientation="vertical"
                variant="middle"
                flexItem
              />
              {endAdornmentSlots.text && (
                <ListItemAvatar
                  sx={adornmentTextAvatar}
                  className={endAdornmentSlotClasses.text}
                >
                  {endAdornmentSlots.text}
                </ListItemAvatar>
              )}
              {endAdornmentSlots.media && (
                <CardMedia
                  sx={adornmentMedia}
                  className={endAdornmentSlotClasses.media}
                  component="img"
                  image={endAdornmentSlots.media}
                />
              )}
            </Box>
          )}
        </Box>
      </ListItemButton>
      {divider && (
        <Divider className="FeatureListItem-bottomDivider" sx={bottomDivider} />
      )}
    </>
  )
}
